export enum SuppotedLocales {
  EN_GB = 'en-gb',
  SV_SE = 'sv-se',
  SV_FI = 'sv-fi',
  SV_AX = 'sv-ax',
  EL_GR = 'el-gr',
  EL_CY = 'el-cy',
}

export enum SupportedLanguages {
  EN = 'en',
  SV = 'sv',
  EL = 'el',
}

export type LocaleConfig = {
  locale: SuppotedLocales
  language: SupportedLanguages
}

export const supportedLocales = [SuppotedLocales.EN_GB, SuppotedLocales.SV_SE, SuppotedLocales.EL_GR]
export const supportedLanguages = [SupportedLanguages.EN, SupportedLanguages.SV, SupportedLanguages.EL]
